import * as React from 'react';
import { Button, Col, Container, Row } from "deda-rkit";

export interface GrigliaCardsProps extends React.HTMLAttributes<HTMLElement>{
    /** Numero di elementi Card da visualizzare nel componente */
    numeroCardVisualizzabili?: number;
    /** Array card da visualizzare nella griglia */
    arrayCard: JSX.Element[];
    /** Testo visualizzato nel bottone per la visualizzazione completa */
    msgBottone?: string;
    /** Stile che si vuole applicare a tutte le colonne delle card*/
    colClassName?: string
    /** Stile che si vuole applicazione al bottone */
    btnClassName?: string

}
 
const GrigliaCards: React.FunctionComponent<GrigliaCardsProps> = ({
    numeroCardVisualizzabili = 6,
    arrayCard = [],
    msgBottone = 'Carica altri risultati',
    colClassName = '',
    btnClassName = 'btn-primary',
    ...attributes
}) => {
    const [apertura, setApertura] = React.useState<boolean>(false);
    
    const numeroCard = arrayCard.length + 1;

    return (
        <Container className={attributes.className} {...attributes}>
            <Row>
                {arrayCard.map((card: JSX.Element, index) => (
                    <Col key={'col_' + card.key} lg="4" xs="12" hidden={index > 5 && !apertura} className={colClassName}>
                       {card}
                    </Col>
                ))}
            </Row>
            <Row>
                {
                    numeroCard > numeroCardVisualizzabili && (
                        <Row>
                            <Button onClick={() => setApertura(!apertura)} className={btnClassName + ' col-auto m-auto'} hidden={apertura}>{msgBottone}</Button>
                        </Row>
                    )
                }

            </Row>
        </Container>
    );
}
 
export default GrigliaCards;